import {
  IPostValidateOtpResponseData,
  IPutForgotPasswordResponseData,
  IValidateOtpRequestData,
} from '../constants/types';
import { PROFILE_API, SEND_OTP, VALIDATE_OTP } from '../constants/apiEndpoints';
import apiClient from '../lib/apiClient';

export const sendOTP = async (email: string) => {
  const response = await apiClient.post(SEND_OTP, {
    email,
    patient_platform: true,
  });
  return response?.data;
};

export async function validateOtp(
  email: string,
  otp: number
): Promise<IPostValidateOtpResponseData> {
  const requestData: IValidateOtpRequestData = { email, otp };
  const response = await apiClient.post<IPostValidateOtpResponseData>(
    VALIDATE_OTP,
    requestData
  );

  return response?.data;
}

export async function putForgotPassword(email: string) {
  const response = await apiClient.put<IPutForgotPasswordResponseData>(
    '/patients/forgot_password',
    { patient: { email } }
  );

  return response.data;
}

export const updateProfile = async ({
  patient_platform_first_login,
  userId,
  ...rest
}: {
  patient_platform_first_login: boolean;
  userId: number;
}) => {
  const response = await apiClient.put(`${PROFILE_API}/${userId}`, {
    patient: {
      patient_platform_first_login,
      ...rest,
    },
  });

  return response?.data;
};
